"use client";

import { ReactLenis } from "lenis/react";
import { PageWrapper } from "@/components/transition-page";
// import { SplashScreen } from "@/components/loading";
import { bebasNue, geistMono, geistSans, moonWalk, raleway, robotoMono, surgena } from "@/lib/metadata";
import { StrictMode, useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { usePathname, useRouter } from "next/navigation";
import Loader from "./templates/photostudio/loader";
import { SplashScreen } from "@/components/loading";
import "@/app/globals.css";

export default function RootLayout({ children }: { children: React.ReactNode }) {
  const [isSplashComplete, setIsSplashComplete] = useState(false);
  const circleRef = useRef<SVGSVGElement | null>(null);
  const logoRef = useRef(null);

  const textRef = useRef<SVGTextElement>(null);
  const pathRef = useRef<SVGPathElement>(null);
  useGSAP(
    () => {
      const path = pathRef.current;
      const text = textRef.current;
      const circle = circleRef.current;
      if (path && text) {
        const length = path.getTotalLength();
        text.setAttribute("textLength", length.toString());
        text.setAttribute("lengthAdjust", "spacingAndGlyphs");
      }

      // buat timeline GSAP
      const tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });

      tl.fromTo(
        circle,
        { opacity: 0.5, y: 500, scale: 0.5, rotate: 0 },
        {
          opacity: 1,
          scale: 1,
          y: 0,
          delay: 2,
          duration: 1.2,
          ease: "circ.out"
        }
      )
        .fromTo(
          text,
          { opacity: 0, y: 0 },
          {
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: "power2.out"
          },
          "-=0.8" // mulai sedikit lebih awal
        )
        .to(
          circle,
          {
            rotate: 360,
            transformOrigin: "50% 50%",
            duration: 8,
            ease: "none"
          },
          "+=0.2"
        )
        .to(circle, {
          y: 600,
          opacity: 0
        });
    },

    { scope: logoRef }
  );
  return (
    <html lang='en'>
      <head>
        <meta charSet='UTF-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      </head>

      <body className={` dark bg-background  ${geistSans.variable}  ${geistMono.variable} ${raleway.variable} ${bebasNue.variable} ${robotoMono.variable} ${surgena.variable} ${moonWalk.variable}  text-foreground relative`}>
        <ReactLenis root />
        {/* Splash screen */}
        {/* {!isSplashComplete && <SplashScreen onComplete={() => setIsSplashComplete(true)} />}
        {isSplashComplete && <PageWrapper>{children}</PageWrapper>} */}
        <StrictMode>
          <PageWrapper>{children}</PageWrapper>

          <div ref={logoRef} className='fixed bottom-10 right-10 z-[9999] md:size-24 size-11 pointer-events-none'>
            <svg ref={circleRef} viewBox='0 0 200 200' className='w-full h-full'>
              <defs>
                <path
                  ref={pathRef}
                  id='circlePath'
                  d='
              M 100,100
              m -75,0
              a 75,75 0 1,1 150,0
              a 75,75 0 1,1 -150,0
            '
                />
              </defs>

              <text ref={textRef} fontSize='20' fill='#EEC303' fontWeight='600' letterSpacing='6'>
                <textPath href='#circlePath' startOffset='0%'>
                  HUCO • HUCO • HUCO • HUCO •
                </textPath>
              </text>
            </svg>
          </div>
        </StrictMode>
      </body>
    </html>
  );
}
